<template>
  <transition name="ewz-modal" :duration="{ enter: 800, leave: 900 }" appear>
    <div :class="classes">
      <div ref="dialog" class="dialog">
        <header v-if="header" class="dialog__header">
          <a class="close-btn" @click="close"></a>
          <slot name="header">
            <div class="dialog__title">{{ title }}</div>
            <div v-if="subTitle" class="dialog__sub-title">{{ subTitle }}</div>
          </slot>
        </header>
        <div class="dialog__body">
          <a v-if="!header" class="close-btn" @click="close"></a>
          <slot></slot>
        </div>
        <footer v-if="$slots.footer" class="dialog__footer">
          <slot name="footer"></slot>
        </footer>
      </div>

      <div class="nested-modals">
        <slot name="nested"></slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    title: { type: String, default: 'Modal Title' },
    subTitle: { type: String, default: null },
    header: { type: Boolean, default: true }
  },

  data: () => ({ overflowing: false }),

  computed: {
    classes() {
      return ['ewz-modal', { 'ewz-modal--overflowing': this.overflowing }]
    }
  },

  mounted() {
    document.addEventListener('keyup', this.onKeyup)
    window.addEventListener('resize', this.checkOverflow)
    this.checkOverflow()
  },

  beforeDestroy() {
    document.removeEventListener('keyup', this.onKeyup)
    window.removeEventListener('resize', this.checkOverflow)
  },

  methods: {
    close() {
      this.$emit('close')
    },
    onKeyup(event) {
      if (event.keyCode === 27) this.close()
    },
    checkOverflow() {
      this.overflowing = this.$refs.dialog.offsetHeight > window.innerHeight
    }
  }
}
</script>

<style lang="scss">
@import './scss/modals';

.ewz-modal {
  // @include GPU;
  will-change: opacity;
  height: 100vh;
  overflow: scroll;
  align-items: center;
  padding: blh(1) 0px;

  &--overflowing {
    align-items: flex-start;
  }

  .lightbox {
    padding: blh(1) 0px;
  }

  .nested-modals {
    position: fixed;
    top: 0px;
    left: 0px;
  }

  .dialog {
    // @include GPU;
    will-change: all;

    &__title {
      color: white;
    }

    &__body {
      position: relative;
    }
  }

  .dialog__sub-title {
    @include OpenSansLight;
    color: rgba(white, 0.7);
    margin: blh(-1) 0px blh(1);
  }

  footer {
    flex-shrink: 0;
  }

  footer .button {
    margin: blh(0.5) 0px;
  }
}

// TRANSITIONS

.ewz-modal-enter-active {
  &.ewz-modal {
    transition: opacity 0.5s $ease-out-quart;
  }

  .dialog {
    transition: all 0.3s $ease-out-back;
    transition-delay: 0.3s;
  }
}

.ewz-modal-leave-active,
.page-leave-active {
  &.ewz-modal {
    transition: opacity 0.5s $ease-out-quart;
    transition-delay: 0.4s;
  }
  .dialog {
    transition: all 0.4s $ease-in-back;
  }
}

.ewz-modal-enter,
.ewz-modal-leave-to,
.ewz-modal.page-leave-to {
  &.ewz-modal {
    opacity: 0;
  }
  .dialog {
    transform: scale(0.8);
    opacity: 0;
  }
}

@include bpXs {
  .ewz-modal-enter-active {
    &.ewz-modal {
      transition: opacity 0.5s $ease-out-cubic;
    }
    .dialog {
      transition: all 0.3s $ease-out-cubic;
      transition-delay: 0.2s;
    }
  }

  .ewz-modal-leave-active,
  .page-leave-active {
    &.ewz-modal {
      transition: opacity 0.4s $ease-out-cubic;
      transition-delay: 0.3s;
    }
    .dialog {
      transition: all 0.3s $ease-in-cubic;
    }
  }

  .ewz-modal-enter,
  .ewz-modal-leave-to,
  .ewz-modal.page-leave-to {
    &.ewz-modal {
      opacity: 0;
    }
    .dialog {
      transform: translateY(100vh);
      opacity: 1;
    }
  }
}

@include bpXs {
  .ewz-modal {
    align-items: flex-start;
    padding: 0px;

    .dialog {
      width: 100vw !important;
      min-height: 100vh !important;
      display: flex;
      flex-direction: column;

      &__body {
        flex-grow: 1;
      }
    }
  }
}
</style>
